// extracted by mini-css-extract-plugin
export default {"container":"Cart_container__MSLug","info":"Cart_info__B4q6C"};